import {Injectable} from '@angular/core';

import 'rxjs/add/operator/map'
import {Http, Headers, RequestOptions, Response, ResponseContentType} from '@angular/http';
import {ApiService} from './api.service';
import * as myGlobals from '../globals';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class SurveyService {

    constructor(private http: Http,
        private apiService: ApiService,
        private authenticationService: AuthenticationService) {
    }

    getSurveyQuestions(projectId,repeatCount) {
        return this.apiService.http_get('/survey/getSurveyQuestions/'+projectId+'/'+repeatCount);
    }
    getSurveyProject() {
        return this.apiService.http_get('/survey/getSurveyProject');
    }
    saveSurvey(data) {
        return this.apiService.http_post('/survey/saveSurveyResponse', data);
    }
    saveSurveyDraft(surveyForm,projectId,draftName,repeatCount,questionId,currentProjectId) {
        return this.apiService.http_post('/survey/saveSurveyResponseDraft', {surveyForm: surveyForm, projectId: projectId,draftName:draftName,repeatCount :repeatCount,viewed_index:questionId,current_project_id:currentProjectId});
    }
    saveSurveyNext(surveyForm,projectId,draftName,repeatCount,questionId,currentProjectId) {
        return this.apiService.http_post('/survey/saveSurveyResponseNext', {surveyForm: surveyForm, projectId: projectId,draftName:draftName,repeatCount :repeatCount,viewed_index:questionId,current_project_id:currentProjectId});
    }
    getDraftQuestions(projectId,repeatCount) {
        return this.apiService.http_get('/survey/getDraftQuestions/'+projectId+'/'+repeatCount);
    }
    getSurveyResponse(projectId,repeatCount) {
        return this.apiService.http_get('/survey/getSurveyResponse/'+projectId+'/'+repeatCount);
    }
    exportResponsePdf(projectId,repeatCount) {
        return this.apiService.http_get('/survey/exportResponsePdf/'+projectId+'/'+repeatCount);
    }
    getResponseDetails(projectId,repeatCount) {
        return this.apiService.http_get('/survey/getResponseDetails/'+projectId+'/'+repeatCount);
    }
    listSurveyResponse() {
        return this.apiService.http_get('/survey/listSurveyResponse');
    }
    deleteResponse(resp) {
        return this.apiService.http_post('/survey/deleteResponse',resp);
    }
    
    exportPdf(projectId, repeatCount) {
        let headers = new Headers({'Authorization': 'Bearer ' + this.authenticationService.token});
        let options = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
        
        return this.http.get(myGlobals.apiUrl+'/survey/exportPdf/' + projectId + '/' + repeatCount, options).map(
        (res) => {
            return new Blob([res.blob()], { type: 'application/pdf' })
        });
    }
    
    exportCategoryOrgsResources(data) {
        let headers = new Headers({'Authorization': 'Bearer ' + this.authenticationService.token});
        let options = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
        
        return this.http.post(myGlobals.apiUrl+'/survey/exportCategoryOrgsResources', data, options).map(
        (res) => {
            return new Blob([res.blob()], { type: 'application/pdf' })
        });
    }
    
    sendResponse(data) {
        return this.apiService.http_post('/survey/sendResponse', data);
    }
    
    saveCounty(data) {
        return this.apiService.http_post('/survey/saveCounty', data);
    }
    
    registerGuest(data) {
        return this.apiService.http_post('/survey/registerGuest', data);
    }
    
    ok211ProviderDetails(data) {
        return this.apiService.http_post('/survey/ok211ProviderDetails', data);
    }
    
    latestDraft() {
        return this.apiService.http_get('/survey/latestDraft');
    }
}


// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/survey.service.ts